const Modal = {
  baseStyle: {
    dialog: {
      background: "background.100",
    },
  },
};

export default Modal;
